module.exports = {"id":"204485","name":"Riyad Mahrez","rating":"84","photo":"./data/images/photos/3/204485.png","club":{"name":"Leicester City","logo":"./data/images/clubs/LeicesterCity.png"},"positions":["MD"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/RiyadMahrez0.json
// module id = 3618
// module chunks = 0